// extracted by mini-css-extract-plugin
export default {"card":"PhysicalSubcategoryBars_card__briUS","title":"PhysicalSubcategoryBars_title__it6Cy"};